module.exports = __webpack_public_path__ + "static/media/app-store-logo.2b84fe9a.svg";